$(window).on("resize", function () {
	SetContainerMaxHeight();
});


function RedirectToReturnURL() {
	window.location.href = $("#ReturnUrl").val();
}

/// ensure it all fits on screen with scrollbar
function SetContainerMaxHeight() {
	var windowHgt = $(window).height();
    var valHeight = ($("#ValidationInfoContainer").length > 0) ? $("#ValidationInfoContainer").height() : 0;
    var titleHeight = ($("#divPageTitle").length > 0) ? $("#divPageTitle").height() : 0;
    var funMsgHeight = ($("#funmsg").length > 0) ? $("#funmsg").height() : 0;
    var languageSelectorHeight = ($("#LanguageSelector").length > 0) ? $("#LanguageSelector").height() : 0;
    var footerHgt = ($(".footer").length > 0) ? $(".footer").height() : 0;
	var newHgt = windowHgt - languageSelectorHeight - (footerHgt * 2) - funMsgHeight - 2 * valHeight - titleHeight - 125;
	if (newHgt < 50)
		newHgt = 50;

	$("#MainContainer").css('max-height', newHgt);
}

// Reset Password for EditUser
function ResetPassword(link) {

	$.ajax({
		url: link,
		data: {
			userId: $("#UserId").val()
		},
		method: "GET",
		success: function (response) {
            if (response.success) {
                var isExternalUser = false;
                if ($("#checkBoxIsExternalUser").length > 0)
                    isExternalUser = $("#checkBoxIsExternalUser").is(':checked');
                var succMsg = $("#PasswordResetSuccessMsg" + (isExternalUser ? "Sso" : "")).val();
                showSuccess(succMsg, "ValidationInfoContainer");
                SetContainerMaxHeight();
            }
			else {
				showError(response.response, "ValidationInfoContainer");
				SetContainerMaxHeight();
			}

		},
		error: function () {
			showError($("#PasswordResetFailedMsg").val(), "ValidationInfoContainer");
			SetContainerMaxHeight();
		}
	});
}

function UserEdit_IsExternalChanged(intUserBt, extUserBt) {
    return UserEdit_SetupExternalUser(intUserBt, extUserBt);
}

function UserEdit_SetupExternalUser(intUserBt, extUserBt) {
    if ($("#editUser_ResetPassword").length > 0)
        $("#editUser_ResetPassword").html(intUserBt);
    if ($("#checkBoxIsExternalUser").length < 1 || $("#AuthenticationId").length < 1)
        return false;
    var comboBox = $("#AuthenticationId").data("kendoDropDownList");
    if (comboBox) {
        var isChecked = $("#checkBoxIsExternalUser").is(':checked');
        $('#IsExternalUserValue').val(isChecked);
        comboBox.enable(isChecked);
        if ($("#editUser_ResetPassword").length > 0)
            $("#editUser_ResetPassword").html(isChecked ? extUserBt : intUserBt);
        return true;
    }
    return false;
}